import React from "react";
import { Select, Space } from "antd";
import styled from "styled-components";

const TablePageInfo = styled.div`
  font-size: 14px;
  text-align: right;
  margin: 10px 0;
`;

type Props = {
  onPageSizeChange: (page: number) => void;
  totalCount: number;
};

const TablePageSizeController = (props: Props) => {
  const { onPageSizeChange, totalCount } = props;

  const pageSizeOptions = [20, 50, 100];

  return (
    <TablePageInfo>
      <Space>
        <span>{`總共${totalCount}筆，每頁顯示`}</span>
        <Select defaultValue={pageSizeOptions[0]} onChange={onPageSizeChange} style={{ marginRight: "10px" }}>
          {pageSizeOptions.map((option) => (
            <Select.Option key={option} value={option}>
              {option}
            </Select.Option>
          ))}
        </Select>
      </Space>
      筆
    </TablePageInfo>
  );
};

export default TablePageSizeController;
